/**
 * @generated SignedSource<<38df6717b9025ff32fbad73cbec6d30f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DismissibleElementsViewerRefetchQuery$variables = {};
export type DismissibleElementsViewerRefetchQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"DismissibleElementsViewer">;
  };
};
export type DismissibleElementsViewerRefetchQuery = {
  response: DismissibleElementsViewerRefetchQuery$data;
  variables: DismissibleElementsViewerRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DismissibleElementsViewerRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DismissibleElementsViewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DismissibleElementsViewerRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DismissedElement",
            "kind": "LinkedField",
            "name": "dismissedElements",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstDismissedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastDismissedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dismissedCount",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UnseenElement",
            "kind": "LinkedField",
            "name": "unseenElements",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastAcknowledgedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewsRemaining",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "09c3d3ade7bc62ef04787d2be233d236",
    "id": null,
    "metadata": {},
    "name": "DismissibleElementsViewerRefetchQuery",
    "operationKind": "query",
    "text": "query DismissibleElementsViewerRefetchQuery {\n  viewer {\n    ...DismissibleElementsViewer\n    id\n  }\n}\n\nfragment DismissibleElementsViewer on Viewer {\n  id\n  user {\n    id\n  }\n  dismissedElements {\n    id\n    key\n    firstDismissedAt\n    lastDismissedAt\n    dismissedCount\n  }\n  unseenElements {\n    id\n    key\n    lastAcknowledgedAt\n    viewsRemaining\n  }\n}\n"
  }
};
})();

(node as any).hash = "db215c789983183574745cb3fbb0903b";

export default node;
